/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideToRefresh)?_c('MglMap',_vm._g(_vm._b({on:{"load":_vm.onMapLoaded}},'MglMap',_vm.actualMapProps,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }